import { cn } from '@/common/lib/cn/cn'
import React, { forwardRef } from 'react'
import { Icon, type IconName } from '../../Icon'

export type CheckboxType = {
    size?: 'sm' | 'md' | 'lg' | 'xl'
    emphasis?: 'neutral' | 'negative' | 'positive' | 'warning'
    disabled?: boolean
    beforeIcon?: IconName
    afterIcon?: IconName
    className?: string
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'>

export const Checkbox = forwardRef<HTMLInputElement, CheckboxType>(
    ({ size = 'md', emphasis = 'neutral', beforeIcon, afterIcon, disabled, className, ...props }, ref) => {
        const inputClasses = cn(
            'checkbox',
            {
                'checkbox-sm': size === 'sm',
                'checkbox-md': size === 'md',
                'checkbox-lg': size === 'lg',
                'checkbox-xl': size === 'xl',
            },
            {
                'checkbox-neutral': emphasis === 'neutral',
                'checkbox-negative': emphasis === 'negative',
                'checkbox-positive': emphasis === 'positive',
                'checkbox-warning': emphasis === 'warning',
                'checkbox-disabled': disabled,
            }
        )

        const labelClasses = cn(className)

        return (
            <label className={labelClasses}>
                {beforeIcon && <Icon name={beforeIcon} />}
                <input type='checkbox' ref={ref} className={inputClasses} disabled={disabled} {...props} />
                {afterIcon && <Icon name={afterIcon} />}
            </label>
        )
    }
)

Checkbox.displayName = 'Checkbox'
